import tw from 'tailwind-styled-components'
export const ButtonAction = tw.button`
text-sm
border-[1px]
rounded-lg
h-[38px]
inline-flex
items-center
hover:brightness-95
transition-all
active:scale-[.97]
`
export const actionsBack = `
float-right
p-4 
border-blueTheme 
text-blueTheme
mt-2
mb-5
`

export const MoreDetailsText = tw.span`
text-sm
font-semibold
text-slate-600
hover:cursor-pointer
hover:brightness-90
transition-all
truncate
inline-flex
items-center
gap-2
`

export const SwitchDiv = tw.div`
flex 
items-center 
gap-2 
mt-1.5
`


export const inputRequiredStyle = `
border
border-errorText
`